import React from "react";
import { Link } from "react-router-dom";
import "./coach-landing.css";
import { trackCoachCtaClick } from "../../analytics/googleAnalytics";

/**
 * El cierre antes del pie, como el de Harbiz («Prueba Harbiz gratis durante 14
 * días · Sin permanencia · Sin tarjeta · Sin límites · Empieza gratis»). Antes
 * la página acababa en las preguntas sin ningún botón: quien llegaba al final
 * convencido tenía que volver arriba a buscarlo.
 */
export default function CoachLandingCierre() {
  return (
    <section className="cierre-section">
      <div className="container">
        <h2 className="cierre-titulo">Tu software de entrenador, gratis desde hoy</h2>
        <p className="cierre-texto">Sin tarjeta · Sin permanencia · Sin límite de clientes</p>
        <div className="cierre-botones">
          <Link
            to="/coach/register"
            className="btn-primary"
            onClick={() => trackCoachCtaClick("coach_landing_cierre")}
          >
            Empieza gratis →
          </Link>
          <Link to="/coach/login" className="cierre-login">
            Ya tengo cuenta
          </Link>
        </div>
      </div>
    </section>
  );
}
